
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 16c-.55 0-1.02-.196-1.412-.588A1.926 1.926 0 014.5 14v-3h3V8.75a4.896 4.896 0 01-1.662-.387A4.395 4.395 0 014.4 7.35v-1.1H3.25L0 3a4.869 4.869 0 012.225-1.625A7.876 7.876 0 014.9.9c.45 0 .887.033 1.313.1.425.067.854.192 1.287.375V0h12v13c0 .833-.292 1.542-.875 2.125A2.893 2.893 0 0116.5 16h-10zm3-5h6v2c0 .283.096.52.287.713.192.191.43.287.713.287s.52-.096.712-.287A.968.968 0 0017.5 13V2h-8v.6l6 6V10h-1.4l-2.85-2.85-.2.2c-.233.233-.48.442-.738.625S9.784 8.3 9.5 8.4V11zM4.1 4.25h2.3V6.4c.2.133.408.225.625.275.217.05.442.075.675.075.383 0 .73-.058 1.038-.175.308-.117.612-.325.912-.625l.2-.2-1.4-1.4a4.845 4.845 0 00-1.625-1.087A5.103 5.103 0 004.9 2.9c-.333 0-.65.025-.95.075-.3.05-.6.125-.9.225L4.1 4.25zM13.5 13h-7v1h7.15a2.824 2.824 0 01-.113-.475A3.539 3.539 0 0113.5 13z","fill":"#304F1A"}})])
          )
        }
      }
    